"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FindBox = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _contexts = require("../../contexts");
var _models = require("../../models");
var _FormattedMessage = require("../FormattedMessage");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')((param)=>{
    let { ownerState: { isSimplifiedCheckout }, theme } = param;
    return {
        textAlign: 'center',
        ...!isSimplifiedCheckout && {
            padding: theme.spacing(14, 0)
        }
    };
});
const FindBox = (param)=>{
    let { onClick } = param;
    const { getTestIdProps } = (0, _testidGenerator.default)();
    const { isSimplifiedCheckout } = (0, _contexts.useCheckoutDeliveryContext)();
    const addButtonOwnerState = {
        isSimplifiedCheckout
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, {
        ownerState: addButtonOwnerState,
        ...getTestIdProps(_models.TestId.FindBox),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Button, {
            fullWidth: true,
            variant: "contained",
            color: "primary",
            startIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.Add, {}),
            ...getTestIdProps(_models.TestId.AddDeliveryMethod),
            sx: {
                maxWidth: {
                    sm: 330
                }
            },
            onClick: onClick,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                id: "addDeliveryMethod"
            })
        })
    });
};
exports.FindBox = FindBox;
